// A picture element that provides desktop and mobile image sources
// based on file naming.
// Provided sources: 1x and 2x desktop and mobile images.

import React from "react";
import { string, bool, number, oneOfType, object } from "prop-types";
import {
  background,
  border,
  color,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
} from "styled-system";
import styled from "@emotion/styled";

const _Picture = styled("picture")(
  layout,
  color,
  space,
  background,
  border,
  grid,
  position,
  shadow,
  typography,
  flexbox
);

function Picture({
  breakpoint = "480px",
  imagePath,
  alt,
  width,
  height,
  hasMobile = false,
  imgProps,
  ...rest
}) {
  const widthAttr = width ? { width } : {};
  const heightAttr = height ? { height } : {};
  const [path, ext] = imagePath.split(".");
  return (
    <_Picture {...rest}>
      <source
        media={hasMobile ? `(min-width: ${breakpoint})` : null}
        srcSet={`${path}.${ext} 1x, ${path.toLowerCase()}@2x.${ext} 2x`}
      />
      {hasMobile && (
        <source
          srcSet={`${path}-m.${ext} 1x, ${path.toLowerCase()}-m@2x.${ext} 2x`}
        />
      )}
      <img
        src={`${path}.${ext}`}
        alt={alt}
        {...widthAttr}
        {...heightAttr}
        {...imgProps}
      />
    </_Picture>
  );
}

Picture.propTypes = {
  breakpoint: string,
  imagePath: string.isRequired,
  alt: string,
  hasMobile: bool,
  width: oneOfType([number, string]),
  height: oneOfType([number, string]),
  imgProps: object,
};

export default Picture;
